/**
 * This component is a exception to the rule of not using the `AbstractInput` component directly
 * It is a simple input that does not require validation nor user input (keyboards or click/touch)
 * It gets its value from a react-hook-form `useWatch` or a plain react `useState`
 */
export function HiddenInput({ name, value }: { name: string; value: string }) {
  return <input type="hidden" name={name} value={value} />
}
